import { ModalConfig, modalContent, modalHeading } from './modal.model';

export type StaffDocumentUploadNoticeTitle = 'notice' | 'warning';
export type StaffDocumentUploadNoticeContentVariant = 'default' | 'communication';

/**
 * Shared first-step modal before staff file upload (Verified notice). Same pattern as cancel-upload `ModalComponent` configs.
 */
export function getStaffDocumentUploadNoticeModalConfig(params: {
  title: StaffDocumentUploadNoticeTitle;
  contentVariant: StaffDocumentUploadNoticeContentVariant;
}): ModalConfig {
  const heading =
    params.title === 'warning'
      ? modalHeading.staffDocumentUploadWarning
      : modalHeading.staffDocumentUploadNotice;
  const modalContentHtml =
    params.contentVariant === 'communication'
      ? modalContent.staffDocumentUploadNoticeCommunication
      : modalContent.staffDocumentUploadNoticeDefault;
  return {
    heading,
    modalContent: modalContentHtml,
    hasDropdown: false,
    hasTemplate: true,
    align: true,
    panelClass: 'staffDocumentUploadNoticeModal',
    buttons: [
      { text: 'Cancel', code: 'N', btnOutline: true },
      { text: 'Upload Files', code: 'Y' }
    ]
  };
}

/** Result payload from `ModalComponent` primary / secondary actions for this notice. */
export function isStaffDocumentUploadNoticeConfirmed(result: unknown): boolean {
  if (result == null || typeof result !== 'object') {
    return false;
  }
  const r = result as { code?: string; confirmed?: boolean };
  return r.code === 'Y' || r.confirmed === true;
}
